
import React from 'react';
import '../../assets/css/orderstatus.css';
import { CMS_LOCATION } from '../../constants/constants';
import { isNullOrUndefined, checkUrlPath } from './CommonFunctions';

const StatusBanner = ({ Status1, Status2, Linktext, Linkurl, ImageUrl, Logo }) => {
    //const loadPath = require.context('../../assets/resources/images', true);
    //const Image = loadPath(Logo);
    //const ImagePath = "https://wwwawsuat.ebiz.verizon.com"+ImageUrl;
    
    if(!isNullOrUndefined(Status1) && Status1.indexOf("shipped") > -1 && !isNullOrUndefined(window.bbuInitData)) { Linkurl = window.bbuInitData.shipmentURL;}
    const ImagePath = CMS_LOCATION + ImageUrl;
    return (
        <section className="battery-status-section" role="region">
            <div className="row">
                <div className="columns tiny-12">
                    <div className="battery-status-wrapper">
                        <div className="battery-status-img">
                            <img alt="Battery" src={ImagePath} />
                        </div>
                        <div className="battery-status-details">
                            <div className="battery-status-text">
                                {Status1}
                            </div>
                            <div className="battery-status-text1">
                                {Status2}
                            </div>
                            <a className="m_button1-next" href={checkUrlPath(Linkurl)} data-track={Linktext} tabIndex="0">{Linktext}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StatusBanner


// WEBPACK FOOTER //
// ./src/components/modules/StatusBanner.js